import { useAppSelector } from 'store';
import { getDefaultTheme, getOpenPagesUrlForBrand, resolveBrandName, resolveThemeClass } from 'utilities/themeUtils';

/**
 * Hook that provides brand-specific configuration based on the current theme.
 * Returns styling classes, theme name, and brand URLs needed across the app.
 */
export const useBrandSelector = () => {
	const cmsTheme = useAppSelector((state) => state.claimContent?.theme);
	const defaultTheme = getDefaultTheme();

	// Safely resolve the theme, with a fallback
	const resolvedTheme = cmsTheme ?? defaultTheme;

	return {
		theme: resolveThemeClass(resolvedTheme), // For example "Codan-theme", "Psk-theme"
		rawTheme: resolveBrandName(resolvedTheme), // For example "codan", "privatsikring"
		openPagesUrl: getOpenPagesUrlForBrand(resolvedTheme), // For example "https://www.codan.dk"
		defaultTheme, // For example "Privatsikring"
	};
};
